import { useState } from "react";
import styles from "./complaintfilter.module.css";
import { Link } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";
import { Search, Plus, Filter, ArrowRight } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import axios from "axios";
import { toast } from "react-smart-toaster";

const STATUS_OPTIONS = [
    { value: "Open", label: "Open" },
    { value: "Resolved", label: "Resolved" },
    { value: "Cancelled", label: "Cancelled" },
];

const PRIORITY_OPTIONS = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
];

const SORT_DATE_OPTIONS = [
    { value: "latest", label: "Latest - Earliest" },
    { value: "erliest", label: "Earliest - Latest" },
];

const ComplaintFilter = ({ setAddModalOpen, filterData, setFilterData, sortData, setSortData, setPage }) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
    const [filterOpen, setFilterOpen] = useState(false);
    const [allProperties, setAllProperties] = useState([]);
    const [apartmentList, setApartmentList] = useState([]);

    useEffect(() => {
        const fetchAllProperties = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setAllProperties(response.data?.data || []);
            }).catch((error) => {
                console.error('[Complaints] Failed to load property list for filter', error);
                toast.error(error?.response?.data?.message || 'Unable to load properties. Please try again.');
            });
        };
        fetchAllProperties();
    }, [getAccessTokenSilently]);

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => {
                    setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; });
                    setPage(0);
                }} />
            </div>
            <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
                <Plus /> <span>Complaints</span>
            </Link>
        </div>

        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>

                {/* Property */}
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                    <Autocomplete
                        fullWidth
                        options={allProperties || []}
                        value={allProperties.find(item => item?.value === filterData?.property) || null}
                        getOptionLabel={(option) => option?.label || ""}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        onChange={(event, newValue) => {
                            const newPropertyValue = newValue?.value || "";
                            setFilterData((prev) => ({ ...prev, property: newPropertyValue, apartment: "" }));
                            setPage(0);

                            if (newPropertyValue) {
                                let propertyTemp = allProperties.filter((i) => i.value === newPropertyValue);
                                setApartmentList(propertyTemp[0]?.apartments || []);
                            } else {
                                setApartmentList([]);
                            }
                        }}
                        renderInput={(params) => (<TextField {...params} label="Property" />)}
                    />
                </div>

                {/* Apartment */}
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
                    <Autocomplete
                        fullWidth
                        options={apartmentList || []}
                        value={apartmentList.find(item => item?.value === filterData?.apartment) || null}
                        getOptionLabel={(option) => option?.label || ""}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        noOptionsText={!filterData?.property ? "Select Property First" : "No options"}
                        onChange={(event, newValue) => {
                            setFilterData((prev) => ({ ...prev, apartment: newValue?.value || "" }));
                            setPage(0);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Apartment"
                                placeholder={apartmentList.length === 0 ? "Select Property First" : "Search apartment"}
                            />
                        )}
                    />
                </div>

                {/* Status */}
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
                    <Autocomplete
                        fullWidth
                        options={STATUS_OPTIONS}
                        value={STATUS_OPTIONS.find(item => item.value === filterData?.status) || null}
                        getOptionLabel={(option) => option?.label || ""}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        onChange={(event, newValue) => {
                            setFilterData((prev) => ({ ...prev, status: newValue?.value || "" }));
                            setPage(0);
                        }}
                        renderInput={(params) => (<TextField {...params} label="Status" />)}
                    />
                </div>

                {/* Priority */}
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
                    <Autocomplete
                        fullWidth
                        options={PRIORITY_OPTIONS}
                        value={PRIORITY_OPTIONS.find(item => item.value === filterData?.priority) || null}
                        getOptionLabel={(option) => option?.label || ""}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        onChange={(event, newValue) => {
                            setFilterData((prev) => ({ ...prev, priority: newValue?.value || "" }));
                            setPage(0);
                        }}
                        renderInput={(params) => (<TextField {...params} label="Priority" />)}
                    />
                </div>

                {/* Sort by Date */}
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
                    <Autocomplete
                        fullWidth
                        options={SORT_DATE_OPTIONS}
                        value={SORT_DATE_OPTIONS.find(item => item.value === sortData) || null}
                        getOptionLabel={(option) => option?.label || ""}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        onChange={(event, newValue) => {
                            setSortData(newValue?.value || "");
                            setPage(0);
                        }}
                        renderInput={(params) => (<TextField {...params} label="Sort by Date" />)}
                    />
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("complaint:create") > -1 && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
                <Plus /> <span>Complaints</span>
            </Link>}
        </div>
    </div>);
};

export default ComplaintFilter;
